import React from "react";

const Spacer = ({ className, variant = 'normal', label }) => {
	if (variant.localeCompare('normal', 'en-US', {sensitivity: 'base'}) === 0 && !className)className = 'spacerNormal';
	if (variant.localeCompare('large', 'en-US', {sensitivity: 'base'}) === 0 && !className)className = 'spacerLarge';

	return (
		<div className={`spacer ${className}`} data-component="Spacer" data-label={`${label}`} />
	);
};

export default Spacer;